{
  "pt": {
    "inspiration_list": {
      "actions": {
        "cancel": "Anular",
        "delete": "Eliminar",
        "deleteMultiple": "Apagar...",
        "delete_cancel": "Cancelar",
        "edit": "Editar",
        "new": "Álbum de inspiração",
        "save": "Guardar",
        "submit": "Enviar",
        "tickBoxesDeletion": "Assinale as caixas de verificação dos ficheiros que pretende eliminar."
      },
      "attributes": {
        "name": "Nome"
      },
      "info": "O que prefere para a sua nova casa? Carregue as fotografias que o inspiram! Os álbuns permitem-lhe organizá-las em diferentes temas: cozinha, casa de banho, mobiliário, ...",
      "labels": {
        "inspiration_list": "Listas de inspiração",
        "inspirationlist": "Álbum de inspiração",
        "inspirations": "Inspirações",
        "noInspirationLists": "Ainda não há lista de inspiração",
        "noInspirations": "Ainda não há inspirações"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Crie álbuns diferentes para a sua cozinha, casa de banho ou mobiliário e carregue fotografias que o inspirem.",
            "title": "Como vai decorar a sua nova casa?"
          }
        }
      },
      "validation": {
        "needTitle": "O título é obrigatório",
        "selectInspirationList": "Selecionar pelo menos uma lista de inspiração"
      }
    }
  }
}